



















































































































































































































import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import DynamicForm from '@/components/shared/DynamicForm.vue';
import MStoreDocumentTypeSelect from '@/components/shared/MStoreDocumentTypeSelect.vue';
import DocumentViewer from '@/components/shared/DocumentViewer.vue';
import MStorePageRange from '@/components/shared/MStorePageRange.vue';
import MStoreThumbnailFirstLastView from '@/components/shared/MStoreThumbnailFirstLastView.vue';
import ErrorNotification from '@/components/shared/ErrorNotification.vue';
import CustomIndexingLookups from '@/components/documentToStore/CustomIndexingLookups.vue';
import MStoreInputInlineUpdate from '@/components/shared/MStoreInputInlineUpdate.vue';
import {
  BaseDocumentSearchModel,
  Cabinet,
  CabinetModel,
  DocumentsToStore,
  DocumentToStoreSearchModel,
  DocumentToStoreTargetDocumentTypeModel,
  DocumentToStoreViewModel,
  DocumentTypeModel,
  ReferenceLookupResultModel,
  ReferenceLookupSearchModel,
  ExistingDocumentOption,
  SchemaModel,
  TargetDocumentTypeSettingsModel,
  ReferenceLookupResultType,
  ReferenceLookupMultiMatchOption,
  ReferenceLookupNoMatchOption,
  DocumentToStoreUpdateModel,
  DocumentViewerToolbarOptionsModel,
  PagesStoreMode,
  DocumentPageModel,
  DocumentViewerConstants,
  ErrorCode,
  StoreConstants
} from '@/types';
import { DocumentsToStoreService, DocumentToStoreService, ReferenceLookupService } from '@/services';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import { ArrayUtils } from '@/utils';
import { FormFieldValidation, StoreDocumentHelpers, confirmationHelper } from '@/mixins';
import MStoreDescriptionButton from '@/components/shared/MStoreDescriptionButton.vue';

export default Vue.extend({
  name: 'DefaultDocumentToStore',
  mixins: [StoreDocumentHelpers, confirmationHelper],
  data() {
    return {
      lastActivity: new Date(),
      pageRangePreviousPageNavigationIsEnabled: false,
      getNextDocument: false,
      pagesStoreMode: PagesStoreMode.NoSplitting,
      pagesStoreModeOptions: [
        { value: PagesStoreMode.ManualPageSelection, label: 'Store a document, specific pages, sections or ranges' },
        { value: PagesStoreMode.BatchSplitting, label: 'Split a batch into documents as you page through' }
      ],
      exportOptions: DocumentViewerConstants.WithoutAcquiringLockExportOptions,
      documentStatusEditing: false,
      applicationDirtyBeforeStatusEdit: false,
      isMultiValuesUpdating: false,
      pageRangeSelectAllPages: false
    };
  },
  methods: {
    ...mapActions('documentToStoreStore', [
      'setDocumentToStoreView',
      'isLoading',
      'setSourceDocumentTypeId',
      'setKeepPagesAfterStoring',
      'setSelectedPages',
      'setAllPagesSelectedWithManualPageSelection',
      'setAllPagesSelectedWithBatchSplitting',
      'setReferencesForNextDocument',
      'setMultiValueReferencesForNextDocument',
      'applyReferencesToNextDocument',
      'setApplyReferencesToNextDocumentEnabled',
      'clearReferencesForNextDocument'
    ]),
    ...mapActions('userPreferencesStore', [
      'setDocumentToStoreTargetDocumentType',
      'setDocumentToStoreTargetDocumentTypeFromPreviousSelection',
      'removeDocumentTypeSelection',
      'setDocumentToStoreCanGetNextDocument',
      StoreConstants.UserPreferences.Actions.SetPagesStoreMode
    ]),
    ...mapActions('documentViewStore', ['showLoadingSpinner', 'removeCachedPagesForDocument', 'updatePageCount']),
    ...mapActions('applicationDirtyStore', ['setApplicationDirty']),
    async loadDocumentPreview(this: any) {
      await this.unloadDocument();
      this.setDocumentSearchModel({
        cabinetId: Cabinet.IncomingDocuments,
        documentId: this.sourceDocumentId,
        documentTypeId: this.sourceDocumentTypeId
      } as BaseDocumentSearchModel);
      this.loadPage(this.pageViewedBeforeAddToExisting);
    },
    setCanGetNextDocument(this: any) {
      this.setDocumentToStoreCanGetNextDocument(this.getNextDocument);
    },
    initialiseDocumentToStoreCanGetNextJob(this: any) {
      const canGetNextDocument = this.getDocumentToStoreCanGetNextDocument;
      if (canGetNextDocument) {
        this.getNextDocument = canGetNextDocument;
        this.setDocumentToStoreCanGetNextDocument(this.getNextDocument);
      }
    },
    async getDocumentToStoreViewAsync(this: any, reloadFromApi: boolean): Promise<DocumentToStoreViewModel> {
      if (!reloadFromApi && this.documentToStoreView.cabinets.length && this.documentToStoreView.dynamicFormSchema.length) {
        return this.documentToStoreView;
      }

      const result = await DocumentToStoreService.getDocumentToStoreViewAsync({
        sourceCabinetId: Cabinet.IncomingDocuments,
        sourceDocumentId: this.sourceDocumentId,
        targetDocumentTypeId: this.targetDocumentTypeId,
        isEditReferences: false
      } as DocumentToStoreSearchModel);

      if (result) {
        if (this.targetDocumentTypeId !== result.targetDocumentTypeId) {
          this.removeDocumentTypeSelection({
            documentTypeId: this.targetDocumentTypeId,
            sourceDocumentType: this.sourceDocumentTypeId
          });
          this.setTargetDocumentType(result.targetDocumentTypeId);
        }
        this.setDocumentToStoreView(result);
      }
      return result;
    },
    async initialiseDocumentToStoreView(this: any, loadDocument: boolean, reloadFromApi: boolean) {
      this.isPageLoading = true;
      this.pagesStoreMode = this.pagesStoreModePreference;
      this.getRetainedReferences();
      try {
        await this.getDocumentToStoreViewAsync(reloadFromApi);

        if (!this.isComponentAlive()) {
          return;
        }

        if (this.getApplyReferencesToNextDocumentEnabled) {
          this.applyReferencesToNextDocument();
        } else {
          if (this.previousTargetCabinetId === this.targetCabinetId) {
            this.applyRetainedReferences();
          }
        }

        if (loadDocument) {
          this.loadDocumentPreview();
        }
      } catch (error) {
        this.$log(error);
      } finally {
        this.isPageLoading = false;
      }
    },
    async onStorePagesClicked(this: any) {
      const isFormValid = await this.validateForm();
      if (!isFormValid) {
        return;
      }
      const allPagesSelectedForStore = this.allPagesAreSelectedForStore;
      this.nextDocumentId = await DocumentsToStoreService.getNextDocumentAsync(this.sourceDocumentTypeId, this.sourceDocumentId, this.getDocumentsToStoreTableSortProperties());
      const success = await this.storePages();
      if (!success) {
        return;
      }

      this.setApplicationDirty(false);

      if (this.getApplyReferencesToNextDocumentEnabled || !this.clearGridAfterUpdate) {
        this.setReferencesForNextDocument(this.referenceFields);
        this.setMultiValueReferencesForNextDocument(this.multiValueReferenceItems);
      } else {
        this.clearReferenceValues();
        if (this.clearDocumentDate) {
          this.setDocumentDateValue(this.initialDocumentDateValue);
        }
      }

      if (!this.selectedKeepPagesAfterStoring) {
        if (allPagesSelectedForStore) {
          if (this.getDocumentToStoreCanGetNextDocument) {
            this.goToNextStoreDocument();
          } else {
            this.goBackToDocumentsToStore();
          }
          return;
        }
        this.updateStateAfterPagesStored();
      }

      this.setFocusAfterPagesStored();
    },
    async onDeleteDocument(this: any) {
      const tableSortPropertiesPreference = this.getDocumentsToStoreTableSortProperties();
      this.nextDocumentId = await DocumentsToStoreService.getNextDocumentAsync(this.sourceDocumentTypeId, this.sourceDocumentId, tableSortPropertiesPreference);
    },
    async validateForm(this: any): Promise<boolean> {
      const isDynamicFormValid = await this.$refs.validationObserver.validate();
      if (!isDynamicFormValid) {
        FormFieldValidation.methods.setFocusOnInvalidField(this);
        return false;
      }
      return true;
    },
    async storePages(this: any): Promise<boolean> {
      this.isSubmitLoading = true;
      try {
        const pages = this.document.viewConversionId || this.document.hasNotification ? null : this.selectedPages;
        const storeModel: DocumentToStoreUpdateModel = {
          targetCabinetId: this.targetCabinetId,
          targetDocumentTypeId: this.selectedTargetDocumentTypeId,
          references: this.referenceValues,
          multiValueReferences: this.multiValueReferences,
          pages,
          existingDocumentId: this.existingDocumentId,
          existingDocumentOption: this.existingDocumentOption,
          documentDate: this.documentDateReferenceValue,
          keepPagesAfterStoring: this.selectedKeepPagesAfterStoring
        };

        const result = await DocumentToStoreService.storeUpdateDocumentAsync(Cabinet.IncomingDocuments, this.sourceDocumentId, storeModel);

        if (result.errorCode === ErrorCode.DocumentPageShuffleSucceededReIndexFailed) {
          this.shuffleSucceededReIndexFailed();
          return false;
        }
      } catch (error) {
        this.$log(error);
        return false;
      } finally {
        await this.$refs.validationObserver.reset();
        this.isSubmitLoading = false;
      }

      return true;
    },
    shuffleSucceededReIndexFailed(this: any) {
      this.initialiseDocumentToStoreView(true, false);
      this.selectedPages = `1-${this.document.totalPages}`;
      this.removeCachedPages();
    },
    onCloseButtonClicked(this: any) {
      this.goBackToDocumentsToStore();
    },
    async goToNextStoreDocument(this: any) {
      await this.unloadDocument();
      if (this.nextDocumentId) {
        this.$router.replace({
          name: DocumentsToStore.DocumentsToStore.name,
          params: { documentId: this.nextDocumentId, documentTypeId: this.sourceDocumentTypeId }
        });
      } else {
        this.goBackToDocumentsToStore();
      }
    },
    async goBackToDocumentsToStore(this: any) {
      const hasUnsavedChangesToKeep: boolean = await this.hasUnsavedChangesToKeepAsync(this.$bvModal, this.isApplicationDirty);
      if (hasUnsavedChangesToKeep) {
        return;
      }
      this.setApplicationDirty(false);
      await this.unloadDocument();
      this.$router.push({
        name: DocumentsToStore.Base.name
      });
    },
    onClearReferences(this: any): void {
      if (this.documentDetailsReadonly) {
        return;
      }
      this.clearReferenceValues();
      this.setFocusToFirstReferenceField();
    },
    setFocusToFirstReferenceField(this: any) {
      this.$nextTick(() => {
        const visibleFields = this.referenceFields.filter((field: any) => !field.componentProperties.hidden);
        if (visibleFields && visibleFields.length) {
          const field: SchemaModel = visibleFields[0];
          this.$refs.dynamicForm.setFocusOnField(field);
        }
      });
    },
    setTargetDocumentType(this: any, targetDocumentTypeId: number): void {
      const targetCabinetId = this.getCabinetIdFromDocumentType(targetDocumentTypeId);
      this.setDocumentToStoreTargetDocumentType({
        targetDocumentTypeModel: {
          sourceDocumentType: this.sourceDocumentTypeId,
          targetDocumentType: targetDocumentTypeId
        } as DocumentToStoreTargetDocumentTypeModel,
        cabinetId: targetCabinetId
      });
    },
    removeCachedPages(this: any) {
      const model = {
        documentId: this.sourceDocumentId,
        pages: this.selectedPageRange
      };
      this.removeCachedPagesForDocument(model);
    },
    updateStateAfterPagesStored(this: any) {
      if (this.selectedPageRange?.length) {
        this.removeCachedPages();
        this.updatePageCount(-this.selectedPageRange?.length);

        let pageToPreview = Math.min(this.currentPage, this.document.totalPages);

        if (this.document.totalPages === 1 || this.pagesStoreMode) {
          this.selectedPages = '1';
          pageToPreview = 1;
        }

        this.loadPage(pageToPreview);
      }
    },
    onPageRangeNavigation(this: any, navigation: number) {
      if (this.pagesStoreMode === PagesStoreMode.BatchSplitting) {
        this.pageRangePreviousPageNavigationIsEnabled = navigation > 0 ? true : this.selectedPages !== '1';
        if (this.currentPage + navigation > this.document.totalPages) {
          return;
        }
        if (this.selectedPageRangeIsAllPages) {
          return;
        }
        this.loadPage(this.currentPage + navigation);
      }
    },
    onPageRangeAllPagesChanged(this: any, allPages: boolean) {
      if (this.pagesStoreMode === PagesStoreMode.BatchSplitting) {
        this.setAllPagesSelectedWithBatchSplitting(allPages);
        if (allPages) {
          this.loadPage(this.document.totalPages);
          return;
        }
        this.pageRangePreviousPageNavigationIsEnabled = false;
        this.loadPage(1);
      }

      if (this.pagesStoreMode === PagesStoreMode.ManualPageSelection) {
        this.setAllPagesSelectedWithManualPageSelection(allPages);
      }
    },
    onPagesStoreModeChanged(this: any, pagesStoreMode: PagesStoreMode) {
      this[StoreConstants.UserPreferences.Actions.SetPagesStoreMode]({ pagesStoreMode });
    },
    onCabinetSelectionChanged(this: any, cabinetId: string) {
      const documentTypeId = this.firstDocumentTypeInCabinet(cabinetId);
      this.setDocumentToStoreTargetDocumentTypeFromPreviousSelection({
        targetDocumentTypeModel: {
          sourceDocumentType: this.sourceDocumentTypeId,
          targetDocumentType: documentTypeId
        } as DocumentToStoreTargetDocumentTypeModel,
        cabinetId
      });
      this.clearExistingDocument();
      this.initialiseDocumentToStoreView(false, true);
    },
    initialiseKeepPagesOption(this: any) {
      this.setKeepPagesAfterStoring(false);
    },
    initialiseAllPagesSelected(this: any) {
      this.setAllPagesSelectedWithBatchSplitting(false);
      this.setAllPagesSelectedWithManualPageSelection(true);
    },
    setFocusAfterPagesStored(this: any) {
      if (this.isFocusToDocumentTypeAfterStore && this.cabinetDocumentTypesCount(this.targetCabinetId) > 1) {
        this.$refs.documentTypeSelect.setFocusToDocumentTypeForSelection();
      } else {
        this.setFocusToFirstReferenceField();
      }
    },
    onDocumentStatusDirty(this: any, statusIsDirty: boolean) {
      if (!statusIsDirty && !this.applicationDirtyBeforeStatusEdit) {
        this.setApplicationDirty(false);
        return;
      }
      if (statusIsDirty) {
        this.setApplicationDirty(true);
      }
    },
    onDocumentStatusEditing(this: any, statusEditing: boolean) {
      if (statusEditing) {
        this.applicationDirtyBeforeStatusEdit = this.isApplicationDirty;
      } else {
        this.applicationDirtyBeforeStatusEdit = false;
      }
      this.documentStatusEditing = statusEditing;
    },
    onDirtyDynamicForm(this: any, dirty: boolean) {
      if (dirty) {
        this.setApplicationDirty(true);
      }
    },
    addToExistingDocument(this: any) {
      if (this.canAddToExistingDocument) {
        this.onAddToExisting();
      }
    }
  },
  computed: {
    ...mapGetters('documentToStoreStore', [
      'errorModel',
      'referenceValues',
      'documentDateReferenceValue',
      'isReadonly',
      'existingDocumentId',
      'existingDocumentOption',
      'targetCabinetId',
      'sourceDocumentTypeId',
      'initialReferenceValues',
      'initialDocumentDateValue',
      'referenceFields',
      'customIndexingLookups',
      'getCabinetIdFromDocumentType',
      'firstDocumentTypeInCabinet',
      'keepPagesAfterStoring',
      'clearDocumentDate',
      'cabinetDocumentTypesCount',
      'isFocusToDocumentTypeAfterStore',
      'documentStatus',
      'documentStatusMaximumLength',
      'pageViewedBeforeAddToExisting',
      'getSelectedPages',
      'allPagesSelectedWithManualPageSelection',
      'allPagesSelectedWithBatchSplitting',
      'getApplyReferencesToNextDocumentEnabled',
      'clearGridAfterUpdate'
    ]),
    ...mapGetters('userPreferencesStore', ['getDocumentToStoreTargetDocumentTypes', 'getDocumentToStoreCanGetNextDocument', 'getDocumentsToStoreTableSortProperties']),
    ...mapGetters('userPreferencesStore', {
      pagesStoreModePreference: StoreConstants.UserPreferences.Getters.PagesStoreMode
    }),
    ...mapGetters('documentViewStore', ['currentPage', 'deletedPage', 'deletedDocumentId']),
    ...mapGetters('applicationDirtyStore', ['isApplicationDirty']),
    ...mapGetters('userStore', ['previousRoute']),
    sourceDocumentId: {
      get(this: any) {
        return Number(this.$route.params.documentId);
      }
    },
    selectedTargetDocumentTypeId: {
      get(this: any) {
        return this.targetDocumentTypeId;
      },
      set(this: any, value: number) {
        if (this.targetCabinetId) {
          this.previousTargetCabinetId = this.targetCabinetId;
        }
        if (this.selectedTargetDocumentTypeId !== value) {
          this.setTargetDocumentType(value);
          this.clearExistingDocument();
          if (value) {
            this.initialiseDocumentToStoreView(false, true);
          }
        }
      }
    },
    selectedKeepPagesAfterStoring: {
      get(this: any) {
        return this.keepPagesAfterStoring;
      },
      set(this: any, value: boolean) {
        this.setKeepPagesAfterStoring(value);
      }
    },
    keepPagesIcon(): string {
      return this.selectedKeepPagesAfterStoring ? 'check-square' : 'square';
    },
    isStoreButtonDisabled(this: any): boolean {
      return !this.targetDocumentTypeId || !this.isSelectedPageRangeValid || this.isSubmitLoading || this.isPageLoading || this.documentStatusEditing || this.isMultiValuesUpdating;
    },
    thumbnailHeader(this: any): string {
      const pages = this.selectedPageRange?.length || this.document?.totalPages;
      return `${pages} page${pages > 1 ? 's' : ''} to Store`;
    },
    documentViewerToolbarOptions(this: any): DocumentViewerToolbarOptionsModel {
      const options: DocumentViewerToolbarOptionsModel = {
        allowPageNavigation: !this.documentViewerNavigationIsDisabled,
        allowPageDelete: !this.documentViewerDeleteIsDisabled,
        allowDocumentDelete: !this.documentViewerDeleteIsDisabled,
        showEditReferences: false,
        pageDeleteNotAllowedTooltip: '',
        documentDeleteNotAllowedTooltip: ''
      };
      return options;
    },
    inBatchSplittingMode(this: any): boolean {
      return this.pagesStoreMode === PagesStoreMode.BatchSplitting;
    },
    documentViewerloadPageOnThumbnailClick(): boolean {
      return !this.inBatchSplittingMode;
    },
    pageRangeIsDisabled(this: any): boolean {
      return !this.isPageSplittingSupported || this.isSubmitLoading;
    },
    pageRangeIsReadonly(this: any): boolean {
      return this.inBatchSplittingMode;
    },
    documentViewerNavigationIsDisabled(this: any): boolean {
      return this.inBatchSplittingMode;
    },
    documentViewerFooterIsHidden(this: any): boolean {
      return !this.inBatchSplittingMode || this.currentPage === 1 || this.selectedPageRangeIsAllPages;
    },
    pageRangeUpdateValueOnPageNavigation(this: any): boolean {
      return !this.inBatchSplittingMode || this.currentPage !== 1;
    },
    storeButtonText(this: any): string {
      const defaultText = 'Store';
      if (!this.selectedPageRange || !this.isPageSplittingSupported) {
        return defaultText;
      }
      return `${defaultText} ${this.selectedPageRange.length} ${this.selectedPageRange.length === 1 ? 'page' : 'pages'}`;
    },
    storeOptionsIsDisabled(this: any): boolean {
      return !this.document || this.document.totalPages === 1 || this.isSubmitLoading;
    },
    documentStatusApiUrl(this: any) {
      return `${this.DOCUMENT_STATUS_API_URL}/${Cabinet.IncomingDocuments}/${this.sourceDocumentId}`;
    },
    documentDetailsReadonly(this: any) {
      return this.isSubmitLoading || this.documentStatusEditing;
    },
    selectedPages: {
      get(this: any) {
        return this.getSelectedPages;
      },
      set(this: any, value: any) {
        this.setSelectedPages(value);
      }
    },
    canAddToExistingDocument(this: any) {
      const targetCabinet = this.targetCabinets?.find((cabinet: CabinetModel) => cabinet.id === this.targetCabinetId);

      const targetDocType = targetCabinet?.documentTypes?.find((docType: DocumentTypeModel) => docType.id === this.targetDocumentTypeId);
      return targetDocType?.canViewDocumentType ?? false;
    },
    applyReferencesToNextDocumentEnabled: {
      get(this: any) {
        return this.getApplyReferencesToNextDocumentEnabled;
      },
      set(this: any, value: any) {
        this.setApplyReferencesToNextDocumentEnabled(value);
      }
    },
    getNextDocumentEnabled: {
      get(this: any) {
        return this.getNextDocument;
      },
      set(this: any, value: any) {
        this.getNextDocument = value;
      }
    },
    isOpenNextDocumentOptionDisabled(this: any): boolean {
      return this.isSubmitLoading || this.isPageLoading || this.keepPagesAfterStoring;
    },
    isKeepPagesOptionDisabled(this: any): boolean {
      return this.isStoreButtonDisabled || this.getNextDocument;
    }
  },
  watch: {
    pagesStoreMode(this: any, newValue: number, oldValue: number) {
      this.pageRangePreviousPageNavigationIsEnabled = false;
      switch (newValue) {
        case PagesStoreMode.BatchSplitting: {
          if (!this.isPageLoading) {
            this.pageRangeSelectAllPages = false;
            this.setAllPagesSelectedWithBatchSplitting(false);
          } else {
            this.pageRangeSelectAllPages = this.allPagesSelectedWithBatchSplitting;
          }
          this.selectedPages = '1';
          if (!this.isPageLoading) {
            this.loadPage(1);
          }
          break;
        }
        case PagesStoreMode.ManualPageSelection: {
          if (!this.isPageLoading) {
            this.pageRangeSelectAllPages = true;
            this.setAllPagesSelectedWithManualPageSelection(true);
            this.loadPage(1);
          } else {
            this.pageRangeSelectAllPages = this.allPagesSelectedWithManualPageSelection;
          }
          break;
        }
      }
    },
    hasDocumentLoaded(this: any, value: boolean) {
      if (value) {
        if (this.pagesStoreMode !== PagesStoreMode.NoSplitting) {
          return;
        } else {
          this.pagesStoreMode = this.isPageSplittingSupported
            ? this.pagesStoreMode === PagesStoreMode.NoSplitting
              ? PagesStoreMode.BatchSplitting
              : this.pagesStoreMode
            : PagesStoreMode.NoSplitting;
        }
      }
    },
    showDocumentCannotBeSplit(this: any, value: boolean) {
      if (value) {
        if (!this.isPageSplittingSupported) {
          this.pageRangeSelectAllPages = true;
        }
      }
    },
    deletedPage(this: any, value: DocumentPageModel) {
      if (value && value.documentId === this.sourceDocumentId) {
        this.selectedPages = ArrayUtils.removePageFromSelection(this.selectedPages, value.pageNumber);
      }
    },
    deletedDocumentId(this: any, value: number) {
      if (value && value === this.sourceDocumentId) {
        this.setApplicationDirty(false);
        if (this.getDocumentToStoreCanGetNextDocument) {
          this.goToNextStoreDocument();
        } else {
          this.goBackToDocumentsToStore();
        }
      }
    }
  },
  mounted(this: any) {
    this.setSourceDocumentTypeId(this.$route.params.documentTypeId);
    this.initialiseDocumentToStoreView(true, false);
    this.initialiseDocumentToStoreCanGetNextJob();
  },
  beforeDestroy(this: any) {
    if (!this.onAddToExistingNavigation) {
      this.initialisePageSelectionValues();
      this.initialiseKeepPagesOption();
      this.initialiseAllPagesSelected();
      if (!this.getApplyReferencesToNextDocumentEnabled) {
        this.clearReferencesForNextDocument();
      }
    }
  },
  created(this: any) {
    this.DOCUMENT_STATUS_API_URL = 'documentToStore/status';
  },
  components: {
    DynamicForm,
    ErrorNotification,
    MStoreDocumentTypeSelect,
    DocumentViewer,
    MStorePageRange,
    MStoreThumbnailFirstLastView,
    LoadingSpinner,
    CustomIndexingLookups,
    MStoreDescriptionButton,
    MStoreInputInlineUpdate,
    MultiValueReferencesInput: () => import('./MultiValueReferencesInput.vue'),
    MStoreFormCheckbox: () => import('../shared/MStoreFormCheckbox.vue')
  }
});
